import { render, staticRenderFns } from "./NotificationsFilter.vue?vue&type=template&id=9847f90e&scoped=true"
import script from "./NotificationsFilter.vue?vue&type=script&lang=js"
export * from "./NotificationsFilter.vue?vue&type=script&lang=js"
import style0 from "./NotificationsFilter.vue?vue&type=style&index=0&id=9847f90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9847f90e",
  null
  
)

export default component.exports